<template>
    <table class="table table-striped mt-3">
        <thead class="thead-light">
        <tr>
            <th>
                Position
            </th>
            <th>
                Betrag
            </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="total in totals">
            <td>
                {{total.label}}
            </td>
            <td>
                {{ formatTotal(total.amount) }}
            </td>
        </tr>
        </tbody>
    </table>
</template>
<script>
    export default {
        props: {
            totals: Array
        },
        data: function () {
            return {
                formatter: new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'})
            }
        },
        methods: {
            formatTotal: function (total) {
                return this.formatter.format(total);
            }
        }
    }
</script>
